import { render } from "./BuekPersonIframe.vue?vue&type=template&id=a0dc4e5c&ts=true"
import script from "./BuekPersonIframe.ts?vue&type=script&lang=ts&external"
export * from "./BuekPersonIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__